import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";

function SideNavSeparator(): React.ReactElement {
    return <View style={styles.sideNavSeparator} />;
}

const styles = StyleSheet.create({
    sideNavSeparator: {
        borderBlockStart: `1px solid ${semanticColor.core.border.neutral.subtle}`,
        marginBlockStart: spacing.small_12,

        // HACK(mdr): The separator is full-bleed, and negates the container's
        //     padding!
        marginInlineStart: -spacing.xSmall_8,
        marginInlineEnd: -spacing.xSmall_8,
    },
});

export default SideNavSeparator;
